/* ==========================================================================
   Bulk / wholesale order modal
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var modal = document.querySelector('[data-tf-bulk-modal]');
    if (!modal || modal.__tfInit) return;
    modal.__tfInit = true;

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    /* close on overlay / X */
    modal.querySelectorAll('[data-tf-bulk-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    /* +/- steppers (event delegation) */
    modal.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-tf-bulk-step]');
      if (stepBtn) {
        var input = stepBtn.parentElement.querySelector('.tf-bulk__qty');
        if (input && !input.disabled) {
          var amount = parseInt(stepBtn.getAttribute('data-tf-bulk-step'), 10);
          var current = parseInt(input.value, 10) || 0;
          input.value = Math.max(0, current + amount);
        }
        return;
      }

      if (e.target.closest('[data-tf-bulk-add]')) {
        addBulk(e.target.closest('[data-tf-bulk-add]'));
      }
    });

    function addBulk(btn) {
      var items = [];
      modal.querySelectorAll('.tf-bulk__qty').forEach(function (input) {
        var qty = parseInt(input.value, 10);
        if (qty > 0) items.push({ id: input.dataset.variantId, quantity: qty });
      });
      if (items.length === 0) { alert('Please select at least 1 item'); return; }

      var original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Something went wrong'); });
          return r.json();
        })
        .then(function () {
          btn.textContent = original; btn.disabled = false;
          var modal = document.querySelector('[data-tf-bulk-modal]');
          if (modal) modal.hidden = true;
          document.body.style.overflow = '';
          if (typeof window.tfOpenCart === 'function') window.tfOpenCart();
          else if (typeof window.tfRefreshCart === 'function') window.tfRefreshCart();
          else window.location.href = '/cart';
        })
        .catch(function (err) {
          alert(err.message || 'Something went wrong');
          btn.textContent = original;
          btn.disabled = false;
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    var modal = document.querySelector('[data-tf-bulk-modal]');
    if (modal) modal.__tfInit = false;
    init();
  });
})();
